export default __webpack_public_path__ + "static/media/sprinter-van.5ad63850.jpg";